/**
 * Admin MCP session-bridge — memória only, same-origin POST minting.
 */

/**
 * @param {string} bridgeUrl
 */
export function createAdminMcpSessionManager(bridgeUrl) {
    /** @type {{ token: string, platformUserId: string|null, platformTenantId: string|null }|null} */
    let session = null;
    let expiresAt = 0;

    function resolveCsrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');

        return meta?.getAttribute('content') ?? null;
    }

    async function mint() {
        const csrf = resolveCsrfToken();
        const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };

        if (csrf) {
            headers['X-CSRF-TOKEN'] = csrf;
        }

        try {
            const response = await fetch(bridgeUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers,
                body: '{}',
            });

            if (! response.ok) {
                session = null;
                expiresAt = 0;
                console.warn(
                    '[chatbot] Admin MCP minting sikertelen:',
                    response.status,
                    bridgeUrl,
                );

                return null;
            }

            const data = await response.json().catch(() => ({}));
            const token = data.token;

            if (typeof token !== 'string' || token === '') {
                session = null;
                expiresAt = 0;
                console.warn(
                    '[chatbot] Admin MCP minting: nincs token a válaszban.',
                    bridgeUrl,
                    data,
                );

                return null;
            }

            const expiresIn = Number(data.expires_in ?? 600);

            session = {
                token,
                platformUserId: typeof data.platform_user_id === 'string' ? data.platform_user_id : null,
                platformTenantId: typeof data.platform_tenant_id === 'string' ? data.platform_tenant_id : null,
            };
            expiresAt = Date.now() + Math.max(60, expiresIn) * 1000 - 30_000;

            return session;
        } catch {
            session = null;
            expiresAt = 0;

            return null;
        }
    }

    async function getSession() {
        if (session !== null && Date.now() < expiresAt) {
            return session;
        }

        return mint();
    }

    return {
        getSession,
        mint,
        isAdminMcpBot: true,
    };
}

/**
 * @param {{ admin_mcp?: { session_bridge_endpoint_url?: string } }|null|undefined} config
 */
export function createAdminMcpSessionFromConfig(config) {
    const bridgeUrl = config?.admin_mcp?.session_bridge_endpoint_url;

    if (typeof bridgeUrl !== 'string' || bridgeUrl === '') {
        return null;
    }

    return createAdminMcpSessionManager(bridgeUrl);
}
